<template>
  <!-- Use mouseup.stop to prevent SideLeft/deselectAllSlides function listens to MouseEvent('mouseup'). -->
  <div
    class="ahaslide-legacy-css design-edit-panel"
    @mouseup.stop
    name="slide-customise-old"
    v-aha-emit-action.view
  >
    <AhaInfoBox
      class="mb-3"
      v-if="$store.state.isRightClickInfoBoxVisible"
    >
      {{ $i18nPresenter.t('You can also right-click your slide to change the design') }}
    </AhaInfoBox>
    <div class="form-group" v-if="!canUseTheme">
      <label class="label-option">{{ $i18nPresenter.t('Themes') }}</label>
      <div class="theme-list">
        <div
          class="theme-item"
          v-for="(item, index) in themes"
          :key="index"
          :class="{active: item.themeActive}"
        >
          <div
            class="theme-content horizontal layout center center-justified"
            :style="{
              'background-image': 'url(' + item.themeThumbnail + ')',
            }"
            @click="selectTheme(item)"
            v-hover-intent="{
              onEnter: () => handleHoverOnTheme(item, 'over'),
              onExit: () => handleHoverOnTheme(item, 'out')
            }"
          >
          </div>
        </div>
      </div>
    </div>
    <div v-if="!canUseTheme" class="pb-4 border-t border-base-30"></div>

    <div
      class="mb-3 check-correct-option-info"
      v-if="selectedSlideIds.length > 1"
    >
      <i class="fas fa-info-circle" />
      <span
        class="pl-1"
        v-html="$i18nPresenter.t('youAreApplyingChangesToXSlides', {
          length: selectedSlideIds.length
        })"
      >
      </span>
    </div>

    <div class="form-group">
      <label class="label-option mb-3">{{ $i18nPresenter.t('Background') }}</label>
      <label>{{ $i18nPresenter.t('Background colour') }}</label>
      <div class="color-list horizontal layout base-color-list center">
        <div
          class="item-color"
          :class="{active: selectedSlide.baseColour == item.color}"
          v-for="item in baseColors"
          :key="item.color"
        >
          <div
            class="color"
            :style="{ 'background-color': item.color }"
            @click="selectBaseColour(item)"
          />
        </div>|
        <div class="custom-color-base horizontal layout center">
          <span>{{ $i18nPresenter.t('Custom:') }}</span>
          <ColorPicker :disableUpdateBaseColor="disableUpdateBaseColor" />
        </div>
      </div>
    </div>

    <div class="form-group relative">
      <label>
        {{ $i18nPresenter.t('Background image') }}
        <!--        <span class="title-table-presentation-tooltip result-layout-tooltip">-->
        <!--          <b-button v-tooltip="$i18nPresenter.t('Max file size: 15MB')" class="tooltip-btn" />-->
        <!--        </span>-->
        <span class="relative">
          <img
            class="cursor-pointer ml-2 mb-0.5"
            src="@/assets/images/pro.svg"
            v-if="isPlanFree && isBeforeCurrentPeriodStart"
            @click=" openUpgradeBackground()"
          />
          <div v-if="ctaUpgradeBackground && isBeforeCurrentPeriodStart" class="upgrade-arrow left-2"></div>
        </span>
      </label>
      <PlanUpgradeModal
        v-if="isBeforeCurrentPeriodStart"
        :plan-for-feature="'Essential'"
        :isShowTooltip="ctaUpgradeBackground"
        :name-feature="'Background Image'"
        @outsideEvent="clickOutsideUpgradeBackground"
      />

      <div class="button-add-image" v-if="!selectedSlide.backgroundImage && !selectedSlide.backgroundCache">
        <aha-button variant="base" class="font-normal" @click="openModalUploadImage">
          <font-awesome-icon icon="image" />
          <span class="pl-1">{{ $i18nPresenter.t('Add image') }}</span>
        </aha-button>
      </div>

      <div
        class="slide-image-config horizontal layout center"
        v-if="thumbnailBackgroundImage"
      >
        <div class="image-box">
          <img :src="thumbnailBackgroundImage" alt>
        </div>
        <div>
          <div v-if="backgroundImageExtension !== 'gif'">
            <a>
              <i class="pr-2 fas fa-arrows-alt" />
              <span @click="handleRepositionButtonClick">{{ $i18nPresenter.t('Reposition') }}</span>
            </a>
          </div>
          <div>
            <a>
              <i class="pr-2 far fa-image" />
              <span @click="openModalUploadImage">{{ $i18nPresenter.t('Change image') }}</span>
            </a>
          </div>
          <div>
            <a>
              <i class="pr-2 fas fa-trash-alt" />
              <span @click="deleteImage()">{{ $i18nPresenter.t('Remove') }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="thumbnailBackgroundImage" class="form-group">
      <label class="label-child-option">
        <span
          v-html="$i18nPresenter.t('backgroundVisibilityX', {
            visibility: selectedSlide.visibility
          })"
        ></span>
      </label>

      <div class="range-limit-choice horizontal layout center">
        <div class="number">
          0%
        </div>
        <b-form-input
          type="range"
          min="0"
          max="100"
          v-model="selectedSlide.visibility"
          @change="updateVisibility"
          :disabled="!thumbnailBackgroundImage"
        />
        <div class="number">
          100%
        </div>
      </div>
    </div>
    <div class="pb-4 border-t border-base-30"></div>
    <div class="form-group">
      <div class="label-option">
        {{ $i18nPresenter.t('Text') }}
        <IconNeedUpgradePlan
          ref="iconNeedUpgradePlanComponentFonts"
          :noPermission="planBenefit.brandingCustomisation &&
            !planBenefit.brandingCustomisation.premiumFontsLibrary"
          :defaultTooltip="$i18nPresenter.t('Changing fonts here affects all slides')"
          left="-40px"
          :upgradePlan="planBenefit.brandingCustomisation.premiumFontsLibrary_planName"
          featureName="Custom Fonts"
          v-if="planBenefit.interactivePresentation"
        />
      </div>
      <div class="d-flex">
        <select-font
          v-model="$store.state.presentation.fontFamily"
          @change="setFontFamily()"
          @hoverChange="testFontFamily"
          @triggerTooltip="triggerTooltipNeedUpdatePlan"
        />
        <div class="color-list horizontal layout center">
          <div
            class="item-color text-colour-setting"
            :class="{active: selectedSlide.textColour == '#ffffff'}"
          >
            <div class="color white" @click="selectTextColour('#ffffff')" />
          </div>
          <div
            class="mx-0 item-color"
            :class="{active: selectedSlide.textColour == '#313131'}"
          >
            <div class="color black" @click="selectTextColour('#313131')" />
          </div>
        </div>
      </div>
    </div>
    <AhaInfoBox
      class="mb-3"
      variant="warning"
      v-if="!isContrastEnough"
    >
      {{
        $i18nPresenter.t('For readability, make sure there is a clear contrast between text colour and base colour.')
      }}
    </AhaInfoBox>
    <div class="pb-4 border-t border-base-30"></div>
    <a
      @click="$emit('on-click-link-to-chart-color')"
      href="#"
      class="link-to-color-palette flex-justify"
    >
      <span class="font-bold flex-justify gap-2">
        <i class="far fa-chart-bar text-lg"></i>
        <span>
          {{ $i18nPresenter.t('Chart colours') }}
        </span>
        <span class="text-pink-50 font-bold bg-pink-10 rounded px-2 py-1">
          {{ $i18nPresenter.t('Beta') }}
        </span>
      </span>
      <aha-icon
        name="chevron-right-2"
        width="10"
        height="16"
        viewBox="0 0 8 14"
      >
      </aha-icon>
    </a>
    <div
      class="form-group mt-8"
    >
      <div class="button-add-image">
        <aha-button
          class="w-full"
          variant="base"
          @click="applyOtherSlide"
          :disabled="isDisableWhenNotOwner"
        >
          <font-awesome-icon icon="clone" />
          <span class="pl-1">{{ $i18nPresenter.t('Apply to other slides') }}</span>
        </aha-button>
      </div>
      <a
        class="set-default right-col--link"
        @click="resetBackgroundConfig"
      >
        {{ resetText }}
      </a>
    </div>

    <aha-modal
      :data="dataConfirm"
      :title="dataConfirm.title"
      v-if="dataConfirm.open"
      @hide="handleModalConfirmApply({ ok: false })"
    >
      {{ dataConfirm.description }}

      <template #action>
        <aha-antd-button
          v-aha-emit-action
          name="cancel-apply-to-other-slides"
          class="mr-2"
          variant="secondary"
          @click="handleModalConfirmApply({ ok: false })"
        >
          {{ $i18nPresenter.t('Cancel') }}
        </aha-antd-button>
        <aha-antd-button
          v-aha-emit-action
          name="confirm-apply-to-other-slides"
          @click="handleModalConfirmApply({ ok: true })"
        >
          {{ $i18nPresenter.t('OK') }}
        </aha-antd-button>
      </template>
    </aha-modal>

    <div v-if="isUploadImageModalShowing">
      <FeatureAIAutoPrefillImageSearchTabs
        v-if="canUseAutoPrefillImageSearchTabs"
        :type="'slideBackgroundImage'"
        @hideModal="hideModalUploadImage"
        @callback="handleUploadFileFinished"
        :updateGifInBackground="handleUpdateGifInBackground"
        @selectExistImage="selectExistImage"
      />
      <UploadImageV2
        v-else
        :type="'slideBackgroundImage'"
        @hideModal="hideModalUploadImage"
        @callback="handleUploadFileFinished"
        :updateGifInBackground="handleUpdateGifInBackground"
        @selectExistImage="selectExistImage"
      />
    </div>

    <CropImageV2
      :aspect-ratio="DEFAULT_IMAGE_RATIOS.BACKGROUND_IMAGE"
      :cropper-data="cropperData"
      v-if="isCropImageModalShowing"
      :image-url="slideBackgroundImageUrl"
      @on-cancel="handleCancelCrop"
      @hideModal="hideCropModal"
      :updateInBackground="handleUpdateInBackground"
    />
  </div>
</template>

<script>
import debounce from 'debounce'
import { mapState, mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import UploadImageV2 from '@/components/presentations/UploadImage.v2.vue'
import Config from '@/config'
import Socket from '@/socket'
import Util from '@/util'
import ColorPicker from '@/components/presentations/ColorPicker.vue'
import Constant from '@/constant'
import EventBus from '@/eventBus'
import CropImageV2 from '@/components/presentations/CropImage.v2'
import FeatureAIAutoPrefillImageSearchTabs from '@/components/presentations/FeatureAIAutoPrefillImageSearchTabs.vue'

import SlideApi from '@/api/slide'
import eventCategories from '@/constant/eventCategories'
import theme from '@/constant/theme'
import UndoRedoMixin from '@/mixins/undo-redo/UndoRedoMixin'
import BackgroundUploadMixin from '@/mixins/slide/BackgroundUploadMixin'
import selectFont from '@/components-v2/font/select'
import {
  removeObjectFromIndexedDB,
  setObjectToIndexedDB,
  Stores,
} from '@/utils/indexedDB/indexed.db'
import {
  copyBackgroundCacheToSlides,
  resetBackgroundCacheToSlides,
} from '@/utils/indexedDB/image.cache.utils'
import PlanUpgradeModal from '@/components-v2/presentation-editor/editor-header/PlanUpgrade.vue'
import IconNeedUpgradePlan from '@/components-v2/my-plan/IconNeedUpgradePlan.vue'

const { PRESENTATION_EDITOR } = eventCategories

export default {
  components: {
    PlanUpgradeModal,
    CropImageV2,
    UploadImageV2,
    ColorPicker,
    selectFont,
    IconNeedUpgradePlan,
    FeatureAIAutoPrefillImageSearchTabs,
  },
  mixins: [UndoRedoMixin, BackgroundUploadMixin],
  data() {
    return {
      ctaUpgradeBackground: false,
      dataConfirm: {
        open: false,
      },
      isUploadImageModalShowing: false,
      isCropImageModalShowing: false,
      baseColors: JSON.parse(JSON.stringify(Constant.defaultBaseColour)),
      visibility: 20,
      themes: JSON.parse(JSON.stringify(theme.presentations)),
      disableUpdateBaseColor: false,
      fonts: [
        {
          label: 'San-serif',
          data: [],
        },
        {
          label: 'Serif',
          data: [],
        },
        {
          label: 'Arabic',
          data: [],
        },
        {
          label: 'Thai',
          data: [],
        },
      ],
      DEFAULT_IMAGE_RATIOS: Constant.DEFAULT_IMAGE_RATIOS,
    }
  },

  computed: {
    ...mapState({
      selectedSlideIds: (state) => state.selections.selectedSlideIds,
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      isBeforeCurrentPeriodStart: (state) => state.currentUser.isBeforeCurrentPeriodStart,
      planBenefit: (state) => state.planBenefit,
    }),

    ...mapGetters(['selectedSlide', 'selectedSlides',
      'isPresenting', 'isBackstage', 'isDisableWhenNotOwner', 'isContrastEnough']),
    ...mapGetters('featureToggles', ['canUseAutoPrefillImageSearchTabs']),
    ...mapGetters('themeModule', [
      'canUseTheme',
      'canViewThemeGallery',
    ]),
    ...mapGetters('slideModule', ['blankStyleSlide']),
    ...mapGetters('history', ['canUseUndoRedoV2']),

    backgroundImageExtension() {
      if (this.slideActive.backgroundCacheExtension) return this.slideActive.backgroundCacheExtension
      if (
        !this.slideActive.backgroundImage
        || !this.slideActive.backgroundImage.large
      ) {
        return null
      }

      return this.slideActive.backgroundImage.large.split('?')[0].split('.').pop()
    },
    isPlanFree() {
      return !this.$store.state.plan || this.$store.state.plan.group === 'free'
    },
    resetText() {
      return this.selectedSlides.length > 1
        ? this.$i18nPresenter.t('Reset these slides to default')
        : this.$i18nPresenter.t('Reset this slide to default')
    },
    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
    thumbnailBackgroundImage() {
      return this.selectedSlide.backgroundImage && this.selectedSlide.backgroundImage.thumbnail
    },
  },

  created() {
    this.preloadThemesCanvasImages()
  },

  async mounted() {
    const self = this
    Object.keys(Constant.fonts).forEach((key) => {
      if (key === 'merriweather' || key === 'ebGaramond' || key === 'robotoSlab') {
        self.fonts[1].data.push(Constant.fonts[key])
      } else if (key === 'cairo') {
        self.fonts[2].data.push(Constant.fonts[key])
      } else if (key === 'kanit') {
        self.fonts[3].data.push(Constant.fonts[key])
      } else {
        self.fonts[0].data.push(Constant.fonts[key])
      }
    })
    if (!this.$store.state.presentation.fontFamily) {
      this.$store.state.presentation.fontFamily = self.fonts[0].data[0]
    }
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    ...mapActions('history', ['setSuppressHistoryAction']),

    clickOutsideUpgradeBackground() {
      this.ctaUpgradeBackground = false
    },
    preloadThemesCanvasImages() {
      const images = []
      this.themes.forEach((item) => {
        if (item.backgroundImage.thumbnail) {
          images.push({
            url: item.backgroundImage.thumbnail,
          })
        }
      })
      images.forEach((image) => {
        Util.preloadImage(image)
      })
    },
    openUpgradeBackground() {
      this.ctaUpgradeBackground = true
    },

    handleHoverOnTheme(item, type, selectedSlides = this.selectedSlides) {
      if (this.canUseUndoRedoV2) {
        this.setSuppressHistoryAction(true)
      }

      if (type === 'over') {
        this.disableUpdateBaseColor = true

        selectedSlides.forEach((slide) => {
          const oldConfigs = {
            textColour: slide.textColour,
            baseColour: slide.baseColour,
            visibility: slide.visibility,
            backgroundImage: slide.backgroundImage,
            backgroundCache: slide.backgroundCache,
          }
          slide.oldCustomSlide = oldConfigs

          const newConfigs = {
            oldCustomSlide: oldConfigs,
            ...item,
            backgroundCache: null,
          }
          Constant.commonSlideAttributes.forEach((attr) => {
            if (newConfigs[attr] !== undefined) {
              slide[attr] = newConfigs[attr]
            }
          })

          if (slide.id === this.$store.state.slideActive.id) {
            this.updateSlideActiveAction(newConfigs)
          }
        })
        EventBus.$emit('eventHandleSetValueTransition')
      } else if (type === 'out') {
        this.disableUpdateBaseColor = false

        // Restore slideActive to its oldCustomSlide values
        this.updateSlideActiveAction({
          ...this.slideActive.oldCustomSlide,
        })

        // Also restore the configurations for all selectedSlides
        selectedSlides.forEach((slide) => {
          if (slide.oldCustomSlide) {
            // Restore each slide to its old configurations
            Object.keys(slide.oldCustomSlide).forEach((attr) => {
              slide[attr] = slide.oldCustomSlide[attr]
            })
          }
        })
        EventBus.$emit('eventHandleSetValueTransition')
        this.setSuppressHistoryAction(false)
      }
    },

    removeOldCustomSlideInSlideActive() {
      // Won't do anything if theme is enabled
      if (this.canUseTheme) return

      this.updateSlideActiveAction({
        oldCustomSlide: null,
      })
    },

    async selectTheme(item, selectedSlides = this.selectedSlides) {
      if (this.canUseUndoRedoV2) {
        this.setSuppressHistoryAction(true)
      }
      this.disableUpdateBaseColor = false
      try {
        this.themes.forEach((themeData) => {
          if (item.themeId !== themeData.themeId) {
            themeData.themeActive = false
          } else {
            themeData.themeActive = true
          }
        })
        this.themes.push()
        this.removeOldCustomSlideInSlideActive()
        selectedSlides.forEach((slide) => {
          slide.oldCustomSlide = null
        })
        this.$store.dispatch('setSyncPresentation', 1)
        copyBackgroundCacheToSlides({
          backgroundCache: item.backgroundImage.large,
          originBackgroundCache: item.backgroundImage.large,
          cropperDataCache: null,
        }, selectedSlides)
        await this.updateMultipleSlides(item, selectedSlides, 'selectTheme')
        this.$store.dispatch('setSyncPresentation', 2)
        Util.mixpanelTracking(
          'Presentation',
          'Theme > Theme Selected',
          `Theme: ${item.themeName}`,
        )
      } catch (error) {
        Sentry.captureException(error)
      }
      this.setSuppressHistoryAction(false)
    },

    applyOtherSlide() {
      this.dataConfirm = {
        title: this.$i18nPresenter.t('Apply to other slides'),
        description:
          this.$i18nPresenter.t('Do you want to apply the same colour and background to all other slides in this presentation?'),
        open: true,
      }
    },

    async handleModalConfirmApply(data) {
      if (!data.ok) {
        this.dataConfirm = {}
        return
      }
      if (!this.dataConfirm.isReset) {
        const payload = {
          textColour: this.slideActive.textColour,
          baseColour: this.slideActive.baseColour,
          visibility: this.slideActive.visibility,
          backgroundImage: this.slideActive.backgroundImage,
          originBackgroundImage: this.slideActive.originBackgroundImage,
          backgroundImageCropperData: this.slideActive.backgroundImageCropperData,
          backgroundCache: this.slideActive.backgroundCache,
          cropperDataCache: this.slideActive.cropperDataCache,
          originBackgroundCache: this.slideActive.originBackgroundCache,
        }
        if (this.slideActive.backgroundCache) {
          copyBackgroundCacheToSlides(this.slideActive, this.presentation.slides)
        } else {
          resetBackgroundCacheToSlides(this.presentation.slides)
        }

        if (!this.anUploadInProgress) {
          await this.updateSlide(payload, this.presentation.slides)
        } else {
          // Apply textColor, baseColor & visibility first
          await this.updateSlide({
            textColour: this.slideActive.textColour,
            baseColour: this.slideActive.baseColour,
            visibility: this.slideActive.visibility,
            backgroundImage: this.slideActive.backgroundImage,
            backgroundCache: this.slideActive.backgroundCache,
            cropperDataCache: this.slideActive.cropperDataCache,
            originBackgroundCache: this.slideActive.originBackgroundCache,
          }, this.presentation.slides)
          // If we request apply all while an in-progress backgroundImage upload is running
          // -> apply all requests will be executed after the image is uploaded successfully
          this.requestedApplyOtherSlides = true
        }
        Util.mixpanelTracking(
          PRESENTATION_EDITOR,
          'Apply to all slide',
          this.$store.state.presentation.id,
        )
      } else {
        this.updateSlideActiveAction(this.blankStyleSlide)
        removeObjectFromIndexedDB(this.slideActive.id, Stores.backgroundImageStore)

        EventBus.$emit('eventHandleSetValueTransition')
        await this.updateSlide(this.blankStyleSlide)
      }
      Util.uploadSlide(this.slideActive, this.presentation)

      this.dataConfirm = {}
    },

    resetBackgroundConfig() {
      const title = this.selectedSlides.length > 1
        ? this.$i18nPresenter.t('Do you want to reset these slides to default?')
        : this.$i18nPresenter.t('Do you want to reset this slide to default?')
      this.dataConfirm = {
        title,
        open: true,
        isReset: true,
      }
    },

    openModalUploadImage() {
      if (this.isPlanFree && this.isBeforeCurrentPeriodStart) {
        this.openUpgradeBackground()
        return
      }
      this.slideBackgroundImageUrl = null
      this.cropperData = null
      this.isUploadImageModalShowing = true
    },

    async deleteImage() {
      this.updateSlideActiveAction({
        backgroundImage: null,
        backgroundCache: null,
        originBackgroundCache: null,
      })
      removeObjectFromIndexedDB(this.slideActive.id, Stores.backgroundImageStore)

      EventBus.$emit('eventHandleSetValueTransition')
      await this.updateSlide({
        backgroundImage: null,
      })
    },

    hideModalUploadImage() {
      this.isUploadImageModalShowing = false
    },

    restoreTextColor(color) {
      this.selectTextColour(color, false)
    },

    async selectTextColour(color, isBackup = true) {
      if (isBackup) {
        // this.backupColor(color)
      }
      this.updateSlideActiveAction({ textColour: color })

      await this.updateSlide({
        textColour: color,
      })
    },

    async updateVisibility() {
      await this.updateSlide({
        visibility: this.selectedSlide.visibility,
      })
      EventBus.$emit('eventHandleSetValueTransition')
    },

    async updateSlide(payload, selectedSlides) {
      const appliedSlides = selectedSlides || this.selectedSlides

      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      payload.presenting = this.isPresentingOrBackstage
      await this.updateMultipleSlides(payload, appliedSlides)

      const changedAttrs = []
      Constant.commonSlideAttributes.forEach((attr) => {
        if (payload[attr] !== undefined) {
          changedAttrs.push(attr)
        }
      })

      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        appliedSlides.length > 1
          ? `Background Tab > Change ${changedAttrs.join(', ')} for multiple slides`
          : `Background Tab > Change ${changedAttrs.join(', ')} for single slide`,
        `Presentation: ${this.$store.state.presentation.id}`,
      )
    },

    async updateMultipleSlides(payload, selectedSlides, type = 'updateSlide') {
      const slides = selectedSlides.map((slide) => ({
        id: slide.id,
        ...payload,
        // Special case for background image
        backgroundImage: payload.backgroundImage && payload.backgroundImage.name,
        originBackgroundImage: payload.originBackgroundImage && payload.originBackgroundImage.name,
      }))

      try {
        this.$store.dispatch('setSyncPresentation', 1)
        // Don't re-update the local state if data is already set
        if (!payload.localUpdateApplied) {
          selectedSlides.forEach((slide) => {
            Constant.commonSlideAttributes.forEach((attr) => {
              if (payload[attr] !== undefined) {
                slide[attr] = payload[attr]
              }
            })
          })
        } else if (payload.backgroundImage) {
          selectedSlides.forEach((slide) => {
            slide.backgroundImage = payload.backgroundImage
            if (slide.id === this.slideActive.id) {
              this.updateSlideActiveAction({
                backgroundImage: payload.backgroundImage,
              })
            }
          })
        }
        await SlideApi.updateSlides({
          presentationId: this.$store.state.presentation.id,
          slides,
          action: 'apply-to-other-slides',
          type,
        })
        this.$store.dispatch('setSyncPresentation', 2)
      } catch (err) {
        this.$store.dispatch('setSyncPresentation', 3)
        throw err
      }
    },

    async selectBaseColour(item) {
      this.disableUpdateBaseColor = true
      this.updateSlideActiveAction({
        baseColour: item.color,
        textColour: item.textColour,
      })
      EventBus.$emit('eventHandleSetValueTransition')
      this.updateBaseColourSlide(item)
    },

    updateBaseColourSlide: debounce(async function (item) {
      await this.updateSlide({
        baseColour: item.color,
        textColour: item.textColour,
      })
      this.disableUpdateBaseColor = false
    }, 1000),

    async customColorBase() {
      EventBus.$emit('eventHandleSetValueTransition')
      await this.updateSlide({
        baseColour: this.$store.state.slideActive.baseColour,
      })
    },

    async handleUpdateGifInBackground(data) {
      const { imageUrl, selectedSlides } = data
      const blob = await fetch(imageUrl).then((r) => r.blob())
      try {
        this.updateBackgroundLocally({
          blob,
          cropperData: null,
          extension: 'gif',
          selectedSlides: data.selectedSlides,
        })
        this.isUploadImageModalShowing = false
      } catch (e) {
        Sentry.captureException(e)
      } finally {
        const uploadLinkResponse = await this.handleUploadLinkImage(imageUrl)
        // resize
        const s3ImageUrl = uploadLinkResponse.body.file
        const resizeResponse = await this.handleResizeImage(s3ImageUrl)

        // update image url to slide object
        const payload = {
          backgroundImage: resizeResponse.body,
          originBackgroundImage: null,
          backgroundImageCropperData: null,
          localUpdateApplied: true,
        }
        // Because we will not update the local state again (i.e. will not update the slideActive.backgroundImage), we should store it somewhere else
        // to use this latest background later on.
        // Use case: Apply background to other slides
        await this.updateSlide(payload, selectedSlides)
        this.isUploadImageModalShowing = false
      }
    },

    async handleUploadFileFinished(imageUrl) {
      const extension = imageUrl.split('?')[0].split('.').pop()

      // if it is a gif file then skip the cropping process
      if (extension !== 'gif') {
        this.cropperData = null
        this.isCropImageModalShowing = true
        this.isUploadImageModalShowing = false
        this.slideBackgroundImageUrl = imageUrl
      }
    },

    handleCancelCrop() {
      this.isCropImageModalShowing = false
      this.isUploadImageModalShowing = true
    },

    updateBackgroundLocally({
      blob, cropperData, extension, selectedSlides,
    }) {
      const url = URL.createObjectURL(blob)
      const isNewImage = !this.cropperData && extension !== 'gif'
      selectedSlides.forEach((slide) => {
        slide.backgroundCache = url
        slide.backgroundCacheExtension = extension
        slide.cropperDataCache = cropperData
        if (isNewImage) {
          slide.originBackgroundCache = this.slideBackgroundImageUrl
        }

        const payload = {
          blob,
          cropperDataCache: cropperData,
          extension,
          originBackgroundCache: (isNewImage) ? this.slideBackgroundImageUrl : slide.originBackgroundCache,
        }
        setObjectToIndexedDB(slide.id, Stores.backgroundImageStore, payload)
      })
      this.updateSlideActiveAction({
        backgroundCache: url,
        backgroundImage: {
          xLarge: url,
          large: url,
          thumbnail: url,
          name: extension,
        },
      })
      EventBus.$emit('eventHandleSetValueTransition')
    },

    async handleUploadCroppedImage(formData) {
      return this.$http.post(Config.api.uploadImage, formData)
    },

    async handleUploadLinkImage(imageUrl) {
      return this.$http.post(Config.api.uploadLink, {
        image: imageUrl,
      })
    },

    async handleResizeImage(imageUrl) {
      const croppedImage = imageUrl.split('?')[0]
      const extension = croppedImage.split('.').pop()
      return this.$http.post(Config.api.uploadSlideImage, {
        extension,
        slideId: this.slideActive.id,
        backgroundImage: imageUrl,
        socketId: Socket.getSocketId(),
        originBackgroundImage: null,
        backgroundImageCropperData: null,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
      })
    },

    createUploadFormData(data) {
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('socketId', Socket.getSocketId())
      formData.append('accessCode', data.accessCode)

      return formData
    },

    async handleUpdateInBackground(data, unfinishedSlideId) {
      this.anUploadInProgress = true
      if (unfinishedSlideId) {
        await this.increaseRetryTime(unfinishedSlideId, Stores.backgroundImageStore)
      } else {
        await this.addUploadTask(
          this.slideActive.id,
          this.presentation.id,
          data,
          Stores.backgroundImageStore,
        )
      }
      try {
        this.updateBackgroundLocally({
          blob: data.blob,
          cropperData: data.cropperData,
          extension: 'jpg',
          selectedSlides: data.selectedSlides,
        })
        this.hideCropModal()
      } catch (e) {
        Sentry.captureException(e)
      } finally {
        const uploadFormData = this.createUploadFormData(data)
        const uploadRes = await this.handleUploadCroppedImage(uploadFormData)

        // because the croppedImage is signed
        // therefore, we need to remove all the queries in the url
        const imageUrl = uploadRes.body.file.location
        const resizeRes = await this.handleResizeImage(imageUrl)

        const payload = {
          backgroundImage: resizeRes.body,
          originBackgroundImage: null,
          backgroundImageCropperData: null,
          localUpdateApplied: true,
        }

        if (this.requestedApplyOtherSlides) {
          await this.updateSlide(payload, this.presentation.slides)
        } else {
          await this.updateSlide(payload, data.selectedSlides)
        }

        if (unfinishedSlideId) {
          await this.removeUploadTask(unfinishedSlideId, Stores.backgroundImageStore)
        } else {
          await this.removeUploadTask(this.slideActive.id, Stores.backgroundImageStore)
        }

        Util.mixpanelTracking('Slide', 'Slide image uploaded ', 'User uploaded image from device')

        // Upload original images after closing cropperjs popup
        if (data.originImageUrl) {
          if (this.requestedApplyOtherSlides) {
            await this.updateSlide({
              backgroundImageCropperData: data.cropperData,
              originBackgroundImage: resizeRes.body.origin,
            }, this.presentation.slides)
          } else {
            await this.updateSlide({
              backgroundImageCropperData: data.cropperData,
              originBackgroundImage: resizeRes.body.origin,
            }, data.selectedSlides)
          }
        }
        this.anUploadInProgress = false

        this.requestedApplyOtherSlides = false
        this.hideCropModal()
      }
    },

    async handleCropImageFinished(data) {
      const { id: activeSlideId } = this.$store.state.slideActive

      // because the croppedImage is signed
      // therefore, we need to remove all the queries in the url
      const croppedImage = data.crop.split('?')[0]
      const extension = croppedImage.split('.').pop()
      const res = await this.$http.post(Config.api.uploadSlideImage, {
        extension,
        slideId: activeSlideId,
        backgroundImage: data.crop,
        socketId: Socket.getSocketId(),
        originBackgroundImage: null,
        backgroundImageCropperData: null,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
      })

      const payload = {
        backgroundImage: res.body,
        originBackgroundImage: null,
        backgroundImageCropperData: null,
      }

      await this.updateSlide(payload)

      this.isCropImageModalShowing = false

      EventBus.$emit('eventHandleSetValueTransition')
      Util.mixpanelTracking('Slide', 'Slide image uploaded ', 'User uploaded image from device')

      // Upload original images after closing cropperjs popup
      if (data.originImageUrl) {
        const originalImageUrlRes = await this.$http.post(Config.api.uploadLink, {
          image: data.originImageUrl,
        })

        await this.updateSlide({
          backgroundImageCropperData: data.cropperData,
          originBackgroundImage: originalImageUrlRes.body.file,
        })
      }
    },

    hideCropModal() {
      this.isCropImageModalShowing = false
    },

    handleRepositionButtonClick() {
      this.isCropImageModalShowing = true
      this.slideBackgroundImageUrl = this.selectedSlide.originBackgroundCache ?
        this.selectedSlide.originBackgroundCache :
        (this.selectedSlide.originBackgroundImage
          || this.selectedSlide.backgroundImage.large)
      if (this.selectedSlide.cropperDataCache) {
        this.cropperData = this.selectedSlide.cropperDataCache
      } else {
        this.cropperData = this.selectedSlide.backgroundImageCropperData
      }
    },

    async selectExistImage(obj) {
      const payload = {
        backgroundImage: obj,
        backgroundCache: null,
        originBackgroundImage: null,
        backgroundCacheExtension: null,
        backgroundImageCropperData: null,
      }

      try {
        await this.updateSlide(payload, this.selectedSlides)
        this.selectedSlides.forEach((element) => {
          removeObjectFromIndexedDB(element.id, Stores.backgroundImageStore)
        })
        EventBus.$emit('eventHandleSetValueTransition')
      } catch (err) {
        Sentry.captureException(err)
      } finally {
        this.isUploadImageModalShowing = false
        EventBus.$emit('selectedMyPhotoItem')
      }
    },

    setFontFamily(fontFamily = this.$store.state.presentation.fontFamily) {
      this.onSetFontFamily = true
      this.$store.dispatch('setSyncPresentation', 1)
      const payload = {
        fontFamily,
        socketId: Socket.getSocketId(),
        accessCode: this.$store.state.presentation.uniqueAccessCode,
      }
      Util.setFontSlideV2(fontFamily)
      this._updatePresentation(payload)
      setTimeout(() => {
        this.onSetFontFamily = false
      }, 200)
    },

    testFontFamily(font) {
      if (this.onSetFontFamily) return
      Util.setFontSlideV2(font)
    },

    _updatePresentation(payload) {
      // eslint-disable-next-line promise/catch-or-return
      this.$http
        .put(Config.api.updatePresentation + this.$route.params.id, payload)
        .then(
          () => {
            // eslint-disable-next-line promise/always-return
            if (payload.fontFamily) {
              Util.mixpanelTracking(
                eventCategories.PRESENTATION_EDITOR,
                'Design > Font changed',
                payload.fontFamily,
                null,
                {
                  slideId: this.slideActive.id,
                },
              )
            }
            this.$store.dispatch('setSyncPresentation', 2)
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
    },

    clickSelectFont() {
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Design > Open font selection box',
        this.$store.state.presentation.id,
      )
    },
    triggerTooltipNeedUpdatePlan() {
      this.$refs.iconNeedUpgradePlanComponentFonts.toggleTooltip()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.design-edit-panel {
  @apply overflow-y-auto px-4 pt-4;
  margin-top: $right-panel-header-height;
  padding-bottom: $right-panel-header-height;
  height: calc(100% - $right-panel-header-height);
}

.link-to-color-palette {
  @apply text-base-100 font-bold;
}

.flex-justify {
  @apply flex items-center justify-between;
}

.range-limit-choice {
  position: relative;
  padding-left: 23px;
  .number {
    color: #999;
    font-size: 14px;
  }

  input {
    margin: 0 16px;
  }

  .value {
    position: absolute;
    top: -16px;
    left: 50%;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    width: 30px;
    height: 30px;
    background-color: $primary-color;
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    margin-left: -15px;
  }
}
.custom-color-base {
  margin-left: 3px;

  span {
    margin-left: 5px;
    margin-right: 5px;
  }
}

.set-default {
  display: block;
  margin: 16px 0;
  text-align: center;
}

.range-limit-choice {
  padding-left: 0;
}

.text-colour-setting {
  margin: 0 5px;
}

.item-color {
  border: 2px solid #ffffff;
  margin-right: 3px;
  border-radius: 4px;
  height: fit-content;
  &:hover {
    cursor: pointer;
  }
  .color {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #cccccc;
    box-shadow: 0 0 0 1pt #ffffff;
    &.black {
      background-color: #313131;
    }

    &.white {
      background-color: #fff;
    }
  }

  &.active {

    .color {
      border: 1px solid $primary-color;
      box-shadow: 0 0 0 1pt $primary-color;
    }
  }
}

.slide-image-config {
  background-color: #f2f2f2;
  .image-box {
    margin: auto 10px auto 0;
    img {
      max-width: 150px;
      max-height: 90px;
    }
  }

  a {
    margin: 16px 0;
  }
}

.theme-list {
  margin-left: -4px;
  margin-right: -4px;

  .theme-content {
    width: 104px;
    height: 65px;
    padding: 10px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0.25rem;
    cursor: pointer;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
    transition: .5s;
    transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
  }

  .theme-name {
    text-align: center;
    font-size: 12px;
  }

  .theme-item {
    display: inline-block;
    margin-bottom: 4px;
    padding-left: 4px;
    padding-right: 4px;

    &:hover {
      .theme-content {
        @apply shadow-lg;
      }
    }

    &.active, &.active:hover {
      .theme-content {
        @apply shadow-lg;
      }

      .theme-name {
        color: $primary-color;
      }
    }
  }
}
.group-select-font{
  padding-right: 20px;
  .select-font{
    select, .select-font-display{
      padding: 0 2rem 0 0.75rem !important;
      border: 1px solid #ddd !important;
      height: 2.5rem !important;
      &:hover, &:active, &:focus{
        border-color: #6A1EBB !important;
      }
    }
  }
}
.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent rgba(40, 46, 62, 1) transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 1.6rem;

}
</style>
